import { ME_KEY } from "@wirevod/app-core";

/** Every TanStack Query key in one place, so invalidation stays consistent. */
export const keys = {
  me: ME_KEY,
  assets: {
    all: ["assets"] as const,
    list: (filters: { status?: string; q?: string }) => ["assets", "list", filters] as const,
    detail: (id: string) => ["assets", "detail", id] as const,
  },
  apiKeys: ["api-keys"] as const,
  members: ["members"] as const,
  invites: ["members", "invites"] as const,
  overview: ["overview"] as const,
};
